import { initTheme, Toaster } from '@bia-auction/ui';
import { t } from '@bia-auction/shared-i18n';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ErrorBoundary } from './components/ErrorBoundary';
import { AuthProvider } from './lib/auth';
import { BRAND } from './lib/config';
import { router } from './router';
import './index.css';

// Document title from configured branding (ADR 0015) — the static index.html title is a
// placeholder overridden here.
document.title = t('app.title', { brand: BRAND });

// Stored light/dark preference onto <html> before the first render, so no route mounts
// against the wrong token set (docs/15 §5). The inline script in index.html has already
// applied it to avoid a flash; this call re-applies it and wires cross-tab sync.
initTheme();

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false } },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <RouterProvider router={router} />
          <Toaster />
        </AuthProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>,
);
